import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { Dropdown } from "react-bootstrap";
import { Translate } from "../../../../Enums/Tranlate";
import DeleteModal from "../../../../common/DeleteModal";

const CardItem = ({ item, index, setShouldUpdate, Service }) => {
	const [deleteModal, setDeleteModal] = useState(false);
	const navigate = useNavigate();
	const lang = useSelector((state) => state.auth?.lang);

	return (
		<tr key={index}>
			<td className="text-wrap-mode">{item[`title_${lang}`]}</td>
			<td className="text-wrap-mode">{item[`job_${lang}`]}</td>
			<td>
				<a href={item?.image} target="_blank" rel="noreferrer">
					<img src={item?.image} alt="leader" width={90} />
				</a>
			</td>
			<td>
				<Dropdown>
					<Dropdown.Toggle className="light sharp i-false">
						<i className="la la-ellipsis-v" style={{ fontSize: "27px" }}></i>
					</Dropdown.Toggle>
					<Dropdown.Menu>
						<Dropdown.Item
							onClick={() => {
								navigate(`/leadership/add-leadership`, {
									state: item,
								});
							}}>
							{Translate[lang]?.edit}
						</Dropdown.Item>
						<Dropdown.Item onClick={() => setDeleteModal(true)}>
							{Translate[lang]?.delete}
						</Dropdown.Item>
					</Dropdown.Menu>
				</Dropdown>
			</td>
			{deleteModal && (
				<DeleteModal
					open={deleteModal}
					titleMsg={item[`title_${lang}`]}
					deletedItem={item}
					modelService={Service}
					setShouldUpdate={setShouldUpdate}
					onCloseModal={setDeleteModal}
				/>
			)}
		</tr>
	);
};
export default CardItem;
